
export class DineEngineError extends Error {
  service?: string;
}
